import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "datepicker-element" }
const _hoisted_2 = {
  id: "`${id}-error`",
  class: "error",
  "aria-live": "assertive",
  role: "alert"
}

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

import { useField } from 'vee-validate';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicDatepicker',
  props: {
    modelValue: {},
    id: {},
    name: {},
    label: {}
  },
  setup(__props: any) {

const props = __props;



const { value, errorMessage, handleChange } = useField(props.name, {
  initialValue: props.modelValue ? props.modelValue : new Date(Date.now()),
  valueProp: props.modelValue
});

const updateDate = (e: Date) => {
  handleChange(e, true)
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString(_ctx.label), 1),
    _createVNode(_unref(VueDatePicker), {
      id: _ctx.id,
      "model-value": _unref(value),
      name: _ctx.name,
      "onUpdate:modelValue": updateDate
    }, null, 8, ["id", "model-value", "name"]),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(errorMessage)), 1)
  ]))
}
}

})